// extracted by mini-css-extract-plugin
module.exports = {"mic":"styles_mic__OCTl6"};